import { orderBy } from 'lodash';
import { fmtMsg } from 'commonui';
import { CommonLocale } from '@/locales/localeid';
import { CommonEntitiesLocale } from "./../../../../locales/localeid";
import { Input, Modal, Button, Table } from "ant-design-vue";
import { Vue, Component } from "vue-property-decorator";
import { ApplicationViews } from "@/util/enum";
import { CommonEntitiesModule } from "@/modules/common-entities";
import { getModule } from "vuex-module-decorators";
import AppSettings from "@/modules/app-settings";

@Component({
	components: {
		Modal,
		Input,
		Table,
		Button,
	}
})
export default class EntityUsageModal extends Vue {
	public ApplicationViews = ApplicationViews;
	public CommonEntitiesModule = CommonEntitiesModule;
	public CommonEntitiesLocale = CommonEntitiesLocale;
	private appSettings = getModule(AppSettings);

	public columns: any = [
		{
			title: fmtMsg(CommonEntitiesLocale.CommonTransitionLessonPlanVersion),
			dataIndex: 'versionName',
			key: 'versionName',
			width: "50%",
		},
		{
			title: fmtMsg(CommonEntitiesLocale.CommonTransitionUnit),
			dataIndex: 'unitName',
			key: 'unitName',
			width: "15%",
		},
		{
			title: fmtMsg(CommonEntitiesLocale.CommonTransitionLesson),
			dataIndex: "lessonName",
			key: "lessonName",
			width: "20%",
		},
		{
			title: fmtMsg(CommonEntitiesLocale.CommonTransitionCount),
			dataIndex: 'count',
			key: 'count',
			width: "15%",
		},
	];

	get isVisible() {
		return CommonEntitiesModule.isUsageModalVisible;
	}

	get cancelText() {
		return fmtMsg(CommonLocale.CommonCancelButtonText);
	}

	get isTeachingActivtities() {
		return this.appSettings.childMenuSelected == ApplicationViews.TeachingActivities;
	}

	get selectedEntity() {
		if (this.isTeachingActivtities) {
			const exposureUsages = [] as any;
			CommonEntitiesModule.selectedEntity.contentExposures
				?.map((exposure) => ({
					id: exposure.id,
					contentId: exposure.content.id,
					title: exposure.content.title
				}))
				.forEach((exposure) => {
					const usage = exposureUsages.find((usage) => usage.contentId == exposure.contentId);
					if (usage) {
						usage.count++;
					} else {
						exposureUsages.push({
							...exposure,
							count: 1
						});
					}
				});
			return {
				...CommonEntitiesModule.selectedEntity,
				exposureUsages
			};
		} else {
			const lessonPlanVersions = [] as any;
			CommonEntitiesModule.selectedEntity.lessonPlanVersions ?.forEach(version => {
				version.lessonPlan ?.forEach(lp => {
					lessonPlanVersions.push({
						versionId: version.id,
						versionName: version.name,
						unitId: lp.unitId,
						unitName: lp.vcsLevel.displayName,
						lessonId: lp.id,
						sequence: lp.sequence,
						lessonName: `Lesson ${lp.sequence}`,
						count: lp.transitionCount,
					});
				});
			});
			return {
				...CommonEntitiesModule.selectedEntity,
				lessonPlanVersions: orderBy(lessonPlanVersions, ["versionName", "unitName", "sequence"], ["asc", "asc", "asc"]),
			};
		}
	}

	get modalTitle() {
		return this.isTeachingActivtities
			? fmtMsg(CommonEntitiesLocale.CommonExposureUsage)
			: fmtMsg(CommonEntitiesLocale.CommonTransitionUsage);
	}

	handleCancel() {
		CommonEntitiesModule.setUsageModalVisible(false);
	}
}
